<fieldset class="panel">
  <div class="text-center mb-2">
    <span class="situacao">Prescrição do Dia - {{ marcacaoAtual.data_Comparecimento | date: 'dd/MM/yyyy' }} {{
      marcacaoAtual.isTravada ? 'Travada' : '' }}</span>
      <button class="btn btn-sm btn-info mr-2" (click)="abrirModalModelos()" title="Gerenciar modelos de prescrição">
      <i class="fa fa-list-alt"></i> Modelos
    </button>
    <button class="btn btn-sm btn-primary mr-2" (click)="imprimir()">Imprimir Aba Atual</button>
    
    <button class="btn btn-sm btn-primary mr-5" (click)="copiarPrescricao()"
      [disabled]="marcacaoAtual.status_Atendimento !== 7 && marcacaoAtual.status_Atendimento !== 6" title="Copia a Prescrição desta aba.">
      <i class="fa fa-clipboard"></i> Copiar
    </button>
    
    <button class="btn btn-sm btn-primary mr-5" (click)="colarPrescricao()"
      [disabled]="!prescricaoCopiada || marcacaoAtual.status_Atendimento != 5"
      title="Cola a prescricao copiada.">
      <i class="fa fa-paste"></i> Colar
    </button>
  </div>

  <ul class="nav nav-tabs mb-2" style="cursor: pointer;">
    <li class="nav-item">
      <a class="nav-link" [class.active]="abaAtiva === 1" (click)="mudarAba(1)">Receita 1</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="abaAtiva === 2" (click)="mudarAba(2)">Receita 2</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="abaAtiva === 3" (click)="mudarAba(3)">Receita 3</a>
    </li>
  </ul>

  <div class="toolbar mb-2 d-flex align-items-center gap-1" title="Negrito">
    <button type="button" class="btn btn-sm btn-light" (click)="format('bold')"><b>N</b></button>
    <button type="button" class="btn btn-sm btn-light" title="Itálico" (click)="format('italic')"><i>I</i></button>
    <button type="button" class="btn btn-sm btn-light" title="Sublinhado" (click)="format('underline')"><u>S</u></button>
    
    <label class="btn btn-sm btn-light color-btn" title="Cor da Fonte">
      <i class="bi bi-palette"></i> <input type="color" (change)="setColor($event)" />
    </label>
    
    <label class="btn btn-sm btn-light color-btn" title="Cor de Fundo">
      <i class="bi bi-brush-fill"></i> <input type="color" (change)="setBackground($event)" />
    </label>
  </div>

 <div [hidden]="abaAtiva !== 1" class="form-control input-demarcado editor-area" 
    [attr.contenteditable]="!marcacaoAtual.isTravada"
    [innerHTML]="prescricao1_SafeHtml" 
    [(contenteditableModel)]="marcacaoAtual.prescricao">
  </div>

  <div [hidden]="abaAtiva !== 2" class="form-control input-demarcado editor-area" 
    [attr.contenteditable]="!marcacaoAtual.isTravada"
    [innerHTML]="prescricao2_SafeHtml" 
    [(contenteditableModel)]="marcacaoAtual.prescricao_2">
  </div>

  <div [hidden]="abaAtiva !== 3" class="form-control input-demarcado editor-area" 
    [attr.contenteditable]="!marcacaoAtual.isTravada"
    [innerHTML]="prescricao3_SafeHtml" 
    [(contenteditableModel)]="marcacaoAtual.prescricao_3">
  </div>
</fieldset>